import { normalize } from 'normalizr';

import { contactSchema } from './entities';

export const types = {
  CONTACT_RECEIVE: 'contacts/contactDetails/entities/CONTACT_RECEIVE',
};

export const entitiesStore = {
  receiveContact: (payload) => ({
    type: types.CONTACT_RECEIVE,
    payload: {
      ...normalize(payload, contactSchema),
    },
  }),
};
